import { render, staticRenderFns } from "./ProcesoPaginasAmarillas.vue?vue&type=template&id=7a485886"
import script from "./ProcesoPaginasAmarillas.vue?vue&type=script&lang=js"
export * from "./ProcesoPaginasAmarillas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports